import React from "react"
import Layout from "./src/components/Layout"
import "./src/styles/global.css"
import { CONSENT_KEY } from "./src/components/CookieBanner"

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

/**
 * Traccia i page view ad ogni navigazione SPA di Gatsby,
 * ma SOLO se l'utente ha già dato il consenso ai cookie.
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return
  if (localStorage.getItem(CONSENT_KEY) !== "accepted") return
  if (typeof window.gtag !== "function") return

  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search + location.hash,
    page_title: document.title,
  })
}
